<template>
    <IdeoFormGroup :label="$t('[[[Tytuł]]]')" :invalid-feedback="form.$errors.first('title')" :state="form.$errors.state('title')" required>
        <IdeoFormInput v-model="form.title" type="text" name="title" counter-mode="remaining" max-chars="128" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Tekst]]]')" :invalid-feedback="form.$errors.first('contents.textAdvertise')" :state="form.$errors.state('contents.textAdvertise')" required>
        <IdeoFormInput v-model="form.contents.textAdvertise" name="textAdvertise" type="text" counter-mode="remaining" max-chars="200" />
    </IdeoFormGroup>
    <div class="col">
        <IdeoFormGroup :label="$t('[[[Link]]]')" :invalid-feedback="form.$errors.first('url')" :state="form.$errors.state('url')" required>
            <IdeoFormInput v-model="form.url" type="text" name="url" counter-mode="remaining" max-chars="512" />
        </IdeoFormGroup>
    </div>
    <IdeoFormGroup
        :label="$t('[[[Wybrany kolor czcionki]]]')"
        :invalid-feedback="form.$errors.first('contents.textColor')"
        :state="form.$errors.state('contents.textColor')"
        required
    >
        <IdeoFormInput v-model="form.contents.textColor" v-focus type="color" name="textColor" :maxlength="20" />
    </IdeoFormGroup>
    <IdeoFormGroup
        :label="$t('[[[Wybrany kolor tła]]]')"
        :invalid-feedback="form.$errors.first('contents.backgroundColor')"
        :state="form.$errors.state('contents.backgroundColor')"
        required
    >
        <IdeoFormInput v-model="form.contents.backgroundColor" v-focus type="color" name="backgroundColor" :maxlength="20" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Kolor treści]]]')" :invalid-feedback="form.$errors.first('contents.color')" :state="form.$errors.state('contents.color')">
        <IdeoFormSelect v-model="form.contents.color" :options="ColorTextOptions()" switch />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ikonka sekcji]]]')" :invalid-feedback="form.$errors.first('contents.icon')" :state="form.$errors.state('contents.icon')">
        <div style="max-height: 200px; overflow-y: auto; display: flex; flex-wrap: wrap; gap: 10px;">
            <label v-for="icon in icons" :key="icon.name" style="width: 100px; text-align: center;">
                <img :src="icon.url" :alt="icon.name" style="max-width: 80px;">
                <div>
                    <input
                        v-model="form.contents.icon"
                        type="radio"
                        :value="icon.name"
                    >
                </div>
            </label>
        </div>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Etykieta &quot Czytaj więcej &quot]]]')" :invalid-feedback="form.$errors.first('contents.czytaj_dalej_etykieta')" :state="form.$errors.state('contents.czytaj_dalej_etykieta')">
        <IdeoFormInput v-model="form.contents.czytaj_dalej_etykieta" type="text" name="readMore" counter-mode="remaining" max-chars="128" />
    </IdeoFormGroup>
</template>

<script lang="ts" setup>
import merge from 'lodash/merge';

defineOptions({
    name: 'AddSettings'
});

const { $t } = useLocalization();

const props = defineProps<{
    modelValue: any;
    websiteId: number;
    locale: string;
    id: number;
}>();

const emit = defineEmits<{
    (event: 'update:modelValue', value: any): void;
}>();

const icons = ref<{ name: string; url: string }[]>([]);

function loadIcons()
{
    const files = import.meta.glob('#layers/prawopl/app/assets/icons/banner_icons/*.png', {
        eager: true,
        import: 'default'
    });

    icons.value = Object.entries(files).map(([path, url]) =>
    {
        const name = (path.split('/').pop() || '').replace('.png', '');

        return { name, url: url as string };
    });
}

const ColorTextOptions = (): Option<number>[] => ([
    { value: 1, text: $t('[[[Czarne ikony]]]') },
    { value: 2, text: $t('[[[Białe ikony]]]') }
]);

const form = ref(props.modelValue);

onMounted(async () =>
{
    form.value.contents = merge({ color: 1 }, form.value.contents);
    loadIcons();
});

watch(() => form.value.contents, () =>
{
    triggerModel();
}, { deep: true });

function triggerModel()
{
    emit('update:modelValue', form.value);
}
</script>
